import Vue from 'vue'
import {prepareDate} from "@/utils";

const initialState = {
  list: [],
  detail: {},
  project: {},
  categories: [],
  branches: [],
  departments: [],
  docTypes: [],
  attachmentTypes: [],
  loading: false,
  upload: false
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  getters: {
    legals(state) {
      return state.detail.legals ? state.detail.legals.map(legal => {
        return {
          ...legal,
          created_at: legal.doc_date,
          name: legal.file_name,
        }
      }) : {}
    }
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    },
    ADD_FILE(state, file) {
      state.detail = {
        ...state.detail,
        attachments: [...state.detail.attachments, file]
      }
    },
    REMOVE_FILE(state, fileId) {
      state.detail = {
        ...state.detail,
        attachments: state.detail.attachments.filter((file) => file.id !== fileId)
      }
    },
    ADD_LEGAL(state, file) {
      state.detail = {
        ...state.detail,
        legals: [...state.detail.legals, file]
      }
    },
    REMOVE_LEGAL(state, fileId) {
      state.detail = {
        ...state.detail,
        legals: state.detail.legals.filter((file) => file.id !== fileId)
      }
    }
  },
  actions: {
    getList({commit}, params) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`project_control/projects/`, {params}).then(response => {
          commit('SET', {key: 'list', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getDetail({commit}, projectId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`project_control/projects/${projectId}/`).then(response => {
          commit('SET', {key: 'detail', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    uploadFile({commit, state}, {file, type}) {
      let data = new FormData()
      data.append('file', file)
      data.append('type', type)
      commit('SET', {key: 'upload', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`project_control/projects/${state.detail.id}/attachments/`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          commit('ADD_FILE', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'upload', val: false})
        })
      })
    },
    removeFile({commit, state}, fileId) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(`project_control/projects/${state.detail.id}/attachments/${fileId}/`).then(() => {
          commit('REMOVE_FILE', fileId)
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    uploadLegal({commit, state}, {file, type}) {
      let data = new FormData()
      data.append('file', file)
      data.append('doc_type', type)
      data.append('doc_date', prepareDate(new Date()))
      commit('SET', {key: 'upload', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.post(`project_control/projects/${state.detail.id}/legals/`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          commit('ADD_LEGAL', response.data)
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'upload', val: false})
        })
      })
    },
    removeLegal({commit, state}, fileId) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(`project_control/projects/${state.detail.id}/legals/${fileId}/`).then(() => {
          commit('REMOVE_LEGAL', fileId)
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getAttachmentTypes({commit}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`project_control/attachment_types/`).then(response => {
          commit('SET', {key: 'attachmentTypes', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getRelations({commit}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.get(`project_control/projects/relations/`).then((response) => {
          commit('SET', {key: 'categories', val: response.data.categories})
          commit('SET', {key: 'departments', val: response.data.departments})
          commit('SET', {key: 'branches', val: response.data.branches})
          commit('SET', {key: 'docTypes', val: response.data.doc_types})
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    create({commit}, project) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: true})
        Vue.axios.post(`project_control/projects/`, project).then((response) => {
          resolve(response)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    update({commit}, {projectId, project}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.put(`project_control/projects/${projectId}/`, project).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getProject({commit}, projectId) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`project_control/projects/relations/?project_id=${projectId}`).then(response => {
          commit('SET', {key: 'project', val: response.data.project})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    }
  }
}
